"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.showDate = exports.changeMonthPage = exports.changeDayPage = void 0;
var web_1 = __importDefault(require("../../config/web"));
var moment_1 = __importDefault(require("moment"));
/**
 * 单日数据-tag页面切换
 * @param index 页面在第几页
 */
function changeDayPage(index) {
    var html = "\n  <div class=\"catemark\">\n    <ul id=\"chart_type\">\n      <li class=\"at linklab spe-padding\">\u5355\u65E5\u6570\u636E</li>\n      <li class=\"linklab spe-padding\">\n        <a href=\"/zrt/monthSummary.html\">\u6708\u5EA6\u7EDF\u8BA1\u6570\u636E</a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"cateday\">\n    <ul>\n      <li data-href=\"historyData\">\u8F6C\u878D\u901A\u6982\u51B5<i></i></li>\n      <li data-href=\"historyZrqjyhz\">\u8F6C\u878D\u5238\u4EA4\u6613\u6C47\u603B<i></i></li>\n      <li data-href=\"historyZrtnhfl\">\u8F6C\u878D\u901A\u5E74\u5316\u8D39\u7387<i></i></li>\n      <li data-href=\"historyZrtbdzqxx\">\u8F6C\u878D\u901A\u6807\u7684\u8BC1\u5238\u4FE1\u606F<i></i></li>\n      <li data-href=\"dayZrtDeposit\">\u8F6C\u878D\u901A\u53EF\u51B2\u62B5\u4FDD\u8BC1\u91D1\u8BC1\u5238\u53CA\u6298\u7B97\u7387<i></i></li>\n    </ul>\n  </div>\n  ";
    $('.day').html(html);
    $('.cateday').find('li').eq(index).addClass('at');
    $('.cateday').find('li').on('click', function () {
        window.location.href = "/zrt/" + $(this).attr('data-href') + ".html";
    });
}
exports.changeDayPage = changeDayPage;
/**
 * 月度统计-tag页面切换
 * @param index 页面在第几页
 */
function changeMonthPage(index) {
    var html = "\n  <div class=\"catemark\">\n    <ul id=\"chart_type\">\n      <li class=\"linklab spe-padding\">\n        <a href=\"/zrt/historyData.html\">\u5355\u65E5\u6570\u636E</a>\n      </li>\n      <li class=\"at linklab spe-padding\">\n        \u6708\u5EA6\u7EDF\u8BA1\u6570\u636E\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"cateday\">\n    <ul>\n      <li data-href=\"monthSummary\">\u8F6C\u878D\u901A\u6708\u7EDF\u8BA1\u6982\u51B5<i></i></li>\n      <li data-href=\"monthDetail\">\u8F6C\u878D\u901A\u6708\u7EDF\u8BA1\u660E\u7EC6<i></i></li>\n      <li data-href=\"monthDetailDeposit\">\u4FDD\u8BC1\u91D1\u6708\u7EDF\u8BA1\u660E\u7EC6<i></i></li>\n    </ul>\n  </div>\n  ";
    $('.month').html(html);
    $('.cateday').find('li').eq(index).addClass('at');
    $('.cateday').find('li').on('click', function () {
        window.location.href = "/zrt/" + $(this).attr('data-href') + ".html";
    });
}
exports.changeMonthPage = changeMonthPage;
/**
 * 当前的日期，数据取的日期
 */
function showDate() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var json, list;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
                        type: 'GET',
                        dataType: 'jsonp',
                        data: {
                            reportName: 'RPT_REFINANCING_TARGET',
                            columns: "TRADE_DATE",
                            pageNumber: 1,
                            pageSize: 1,
                            sortTypes: -1,
                            sortColumns: 'TRADE_DATE'
                        }
                    })];
                case 1:
                    json = _c.sent();
                    list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                    return [2 /*return*/, moment_1["default"]((_b = list[0]) === null || _b === void 0 ? void 0 : _b.TRADE_DATE).format('YYYY-MM-DD')];
            }
        });
    });
}
exports.showDate = showDate;
